import { Http, URLSearchParams } from '@angular/http';
import { Injectable } from '@angular/core';

import { AuthHttp } from 'angular2-jwt';
import 'rxjs/add/operator/toPromise';

import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../seguranca/auth.service';
import { TutPerfilHasConteudo } from '../../model/tutoriais.model';

export class TutPerfilHasConteudoFiltro {
    perfil;
    tutConteudo;
    tutTopico;

    pagina = 0;
    itensPorPagina = 20;
}

@Injectable()
export class TutPerfilHasConteudoService {

    url: string;

    constructor(private http: AuthHttp,
        private httpPub: Http,
        public auth: AuthService,) {
        this.url = `${environment.apiUrl}/tut-perfil-has-conteudo`;
    }

    pesquisar(filtro: TutPerfilHasConteudoFiltro): Promise<any> {
        const params = new URLSearchParams();

        params.set('page', filtro.pagina.toString());
        params.set('size', filtro.itensPorPagina.toString());

        if (filtro.perfil) {
            params.set('perfil', filtro.perfil);
        }

        if (filtro.tutConteudo) {
            params.set('tutConteudo', filtro.tutConteudo);
        }

        if (filtro.tutTopico) {
            params.set('tutTopico', filtro.tutTopico);
        }

        return this.http.get(`${this.url}`, { search: params })
            .toPromise()
            .then(response => {
                return response.json();
            })
    }

    pesquisaPublica(filtro: TutPerfilHasConteudoFiltro): Promise<any> {
        const params = new URLSearchParams();

        params.set('page', filtro.pagina.toString());
        params.set('size', filtro.itensPorPagina.toString());

        if (filtro.perfil) {
            params.set('perfil', filtro.perfil);
        }

        if (filtro.tutConteudo) {
            params.set('tutConteudo', filtro.tutConteudo);
        }

        return this.httpPub.get(`${this.url}/pesquisa-publica`, { search: params })
            .toPromise()
            .then(response => {
                return response.json();
            })
    }

    listarTodos(): Promise<any> {
        return this.http.get(this.url)
            .toPromise()
            .then(response => response.json().content);
    }

    excluir(codigo: number): Promise<void> {
        return this.http.delete(`${this.url}/${codigo}`)
            .toPromise()
            .then(() => null);
    }

    adicionar(entidade: TutPerfilHasConteudo): Promise<TutPerfilHasConteudo> {
        return this.http.post(this.url, JSON.stringify(entidade))
            .toPromise()
            .then(response => response.json());
    }

    atualizar(entidade: TutPerfilHasConteudo): Promise<TutPerfilHasConteudo> {

        return this.http.put(`${this.url}/${entidade.id}`,
            JSON.stringify(entidade))
            .toPromise()
            .then(response => response.json() as TutPerfilHasConteudo);
    }

    buscarPorCodigo(codigo: number): Promise<TutPerfilHasConteudo> {
        return this.http.get(`${this.url}/${codigo}`)
            .toPromise()
            .then(response => {
                const entidade = response.json() as TutPerfilHasConteudo;
                return entidade;
            });
    }

}
